export const checkoutLocale = "es-VE";

export const checkoutCopy = {
  pageTitle: "Resumen de la orden",
  order: {
    headingPrefix: "Orden",
    dateLabel: "Fecha de la orden",
    subtotal: "Subtotal",
    taxes: "Impuestos",
    total: "Total",
    loading: "Cargando tu checkout…",
    errorFallback: "No pudimos cargar tu orden en este momento. Intenta nuevamente más tarde.",
    unexpectedLoadError: "Ocurrió un error inesperado al cargar los datos del checkout.",
    discount: "Descuento promocional",
    originalTotal: "Total antes del descuento",
    couponLabel: "Código promocional",
    couponPlaceholder: "Ej. BDAY-LUNA-2026",
    applyCoupon: "Aplicar",
    removeCoupon: "Quitar",
  },
  payment: {
    heading: "Métodos de pago",
    description: "Elige un método de pago para completar tu compra de forma segura.",
    primaryAction: "Completar pago",
    processing: "Procesando…",
    selectMethodValidation: "Selecciona un método de pago para continuar.",
    genericError: "No pudimos procesar tu pago. Por favor, inténtalo de nuevo.",
    unexpectedStatus: "No pudimos confirmar el estado de tu pago. Contacta soporte si el problema persiste.",
    detailsHeading: "Detalles del pago",
    mobileAmountLabel: "Monto a pagar en Bs.",
    exchangeRateLabel: "Tasa referencial (VES/USD)",
    exchangeRateLoading: "Obteniendo tasa de cambio…",
    exchangeRateError: "No pudimos obtener la tasa de cambio. Intenta de nuevo en un momento.",
    transferInfoTitle: "Datos del receptor",
    transferInfoLabels: {
      bankName: "Banco",
      accountNumber: "Número de cuenta",
      phoneNumber: "Teléfono",
      email: "Correo",
      dni: "Documento",
    },
    selectPlaceholder: "Selecciona una opción",
    missingField: (fieldLabel: string) => `Completa “${fieldLabel}” para continuar.`,
    voucherHeading: "Comprobante de pago",
    voucherLabel: "Cargar comprobante",
    voucherHelper: "Selecciona el comprobante emitido por tu banco o billetera.",
    voucherAccepted: "Formatos aceptados",
    voucherMaxSize: "Hasta {size} MB",
    voucherRequired: "Carga el comprobante de pago para continuar.",
    fields: {
      dniLabel: "Tipo de documento",
      dniPlaceholder: "Selecciona el tipo de documento",
      dniNumberLabel: "Número de documento",
      dniNumberPlaceholder: "12345678",
    phoneLabel: "Número de teléfono",
    phonePrefixLabel: "Prefijo",
    phonePrefixPlaceholder: "",
    phoneNumberLabel: "Número",
    phonePlaceholder: "1234567",
    mobileAmountLabel: "Monto a pagar en Bs.",
    exchangeRateLabel: "Tasa referencial (VES/USD)",
    exchangeRateLoading: "Obteniendo tasa de cambio…",
    exchangeRateError: "No pudimos obtener la tasa de cambio. Intenta de nuevo en un momento.",
    bankLabel: "Banco",
    bankPlaceholder: "Nombre del banco emisor",
    referenceLabel: "Número de referencia",
      referencePlaceholder: "0000000000",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "nombre@ejemplo.com",
    },
    stripe: {
      heading: "Datos de la tarjeta",
      cardNumberLabel: "Número de tarjeta",
      cardNumberPlaceholder: "4242 4242 4242 4242",
      expiryLabel: "Fecha de expiración",
      expiryPlaceholder: "MM/AA",
      cvcLabel: "Código de seguridad",
      cvcPlaceholder: "000",
      missingKey: "Los pagos con tarjeta no están disponibles. Contacta soporte.",
      unavailable: "No pudimos cargar el servicio de pagos con tarjeta. Recarga la página o inténtalo más tarde.",
      notReady: "Estamos preparando el formulario de tarjeta. Intenta de nuevo en un momento.",
      tokenizationError: "No pudimos validar los datos de tu tarjeta. Revisa la información e inténtalo otra vez.",
    },
  },
  status: {
    unknownMethodName: "Método de pago no especificado",
    processing: {
      title: "Estamos revisando tu pago",
      description: "Gracias por tu paciencia mientras verificamos tu transferencia.",
      referenceLabel: "Código de referencia",
      methodLabel: "Método de pago",
      updatedAtLabel: "Última actualización",
    },
    success: {
      title: "Pago completado con éxito",
      description: "Tu pago fue confirmado. Esto es lo que registramos para esta transacción.",
      summaryTitle: (orderCode: string) => `Resumen de pago de la orden ${orderCode}`,
      amountLabel: "Monto pagado",
      referenceLabel: "Código de referencia",
      methodLabel: "Método de pago",
      processedAtLabel: "Procesado el",
    },
    return: {
      action: "Volver a la app",
      hint: "Si nada sucede, abre PetsrWise desde la lista de aplicaciones de tu dispositivo.",
    },
  },
};
